import { IGenesysFile } from "../interface/IMessage";

export default function isIGenesysFile(obj: any): obj is IGenesysFile {
  return (
    typeof obj === "object" && obj !== null && typeof obj.filename === "string"
  );
}
